export default __webpack_public_path__ + "static/media/Montserrat-Bold.180ba33d.woff";